import { Divider as MuiDivider } from "@mui/material";

type DividerColor = "neutral-soft";

const COLOR_MAP: Record<DividerColor, string> = {
  "neutral-soft": "var(--color-stroke-neutral-soft)",
};

type Props = {
  orientation?: "vertical" | "horizontal";
  color?: DividerColor;
};

export const Divider = ({ orientation = "horizontal", color }: Props) => {
  return (
    <MuiDivider
      orientation={orientation}
      sx={{ borderColor: color ? COLOR_MAP[color] : COLOR_MAP["neutral-soft"] }}
    />
  );
};
